/* eslint-disable  @typescript-eslint/no-explicit-any */
import { PersistConfig, createMigrate } from 'redux-persist'
import { clearLocalStorageExceptWhitelist, RootState } from './rootReducer'
import Transforms from './setTransform'
import { storageDb } from '../services/localforage'
import localforage from 'localforage'

const migrations = {
  0: (state: any) => {
    return {
      ...state,
    }
  },
  1: (state: any) => {
    // Loop over localStorage and use localforage.setItem
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key) {
        const value = localStorage.getItem(key)
        if (value) {
          // Store each item in localForage
          localforage.setItem(key, value)
        }
      }
    }

    // Clear localStorage after data is migrated to localForage
    // This migration will only run once, but will log users out, as it clears MSAL data cache as well.
    clearLocalStorageExceptWhitelist()
    return state
  },
}

export const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  version: 1,
  storage: storageDb,
  // serialize: false,
  migrate: createMigrate(migrations),
  transforms: Transforms,
  blacklist: [
    'sales',
    'orders',
    'stores',
    'remoteConfig',
    'declarations',
    'stocks',
    'cart',
    'costPrice',
    'nutrition',
    'products',
    'quotes',
    'auth',
  ],
}
